module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/ogp-ad396d31c5306d81c414e02f402b731b.webp";